var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentType != null && _vm.isset(_vm.componentType))?_c(_vm.componentType,_vm._g(_vm._b({key:_vm.type,tag:"component",attrs:{"result":_vm.result,"additional":_vm.additional,"hideDetails":_vm.hideDetails}},'component',_vm.additional,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }